import { ReactNode } from 'react'

import { Practitioner } from '~/storm'

import { PractitionerPreviewContent } from './PractitionerPreviewContent/PractitionerPreviewContent'
import { PractitionerPreviewHeader } from './PractitionerPreviewHeader'

type Props = {
    practitioner: Practitioner
    children?: ReactNode
}

export const PractitionerPreview = ({ practitioner, children }: Props) => (
    <div className="flex w-64 flex-col py-4">
        <PractitionerPreviewHeader practitioner={practitioner} />
        <div className="px-4 pt-3">
            <PractitionerPreviewContent practitioner={practitioner} />
            {children}
        </div>
    </div>
)
